import MasterUploader from "@/components/MasterUploader";
export default function StudentCategories() {
  return (
    <MasterUploader
      kind="categories"
      title="Student Categories"
      subtitle="Links Program × Entity × Specialization. This linkage drives the ceremony sequence."
      columns={[
        { key: "student_category_id", label: "Category ID", mono: true },
        { key: "program_id", label: "Program ID", mono: true },
        { key: "program_name", label: "Program" },
        { key: "entity_id", label: "Entity ID", mono: true },
        { key: "entity_name", label: "Entity" },
        { key: "specialization_id", label: "Spec. ID", mono: true },
        { key: "specialization_name", label: "Specialization" },
      ]}
      templateHint="student_category_id, program_id, entity_id, specialization_id"
    />
  );
}
